import AssetForm from './AssetForm.vue';

export default AssetForm;
